import useWebData from '../../hooks/useWebData';

const Terms = () => {
  const { webData }: any = useWebData();
  document.title = webData?.companyName + " | Terms";

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center text-gray-800">Terms & Conditions</h1>

      <p className="text-gray-700 mb-6">
        Welcome to {webData?.companyName}. Please review these terms and conditions carefully before using our van rental services. By renting a vehicle with us, you agree to the following terms:
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Scope of Use</h2>
        <p className="text-gray-600">
          Renter will use the rented vehicle only for personal or routine business use and operate it on properly maintained roads and parking lots. Renter must comply with all applicable laws regarding licensing and operation. The vehicle must not be subleased, used for hire, or driven under any structure less than 5 feet in height.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Security Deposit</h2>
        <p className="text-gray-600">
          A security deposit of $300.00 is required ($500.00 for debit card customers). Owner may alternatively place a hold on a credit card for the same amount. This deposit may be used to cover damage or loss during the rental. If costs exceed the deposit, the renter is responsible for the remaining balance.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Insurance</h2>
        <p className="text-gray-600">
          Renter must provide proof of insurance that covers both the rental vehicle and personal injury. In case of damage, renter agrees to pay any deductible and assign insurance claims to the owner. If the renter’s insurance declines the claim, the renter remains liable for the full cost of damages.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Indemnification</h2>
        <p className="text-gray-600">
          Renter agrees to indemnify and hold harmless the owner from any legal action or damages resulting from renter’s use of the vehicle. This includes attorney fees, traffic tickets, moving violations, or citations incurred during the rental period.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Representations and Warranties</h2>
        <p className="text-gray-600">
          Owner represents the vehicle is in good condition and safe for standard operation. Renter confirms they are legally licensed to operate a motor vehicle and will not drive illegally or negligently. Any existing vehicle damage must be documented before taking possession.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Jurisdiction and Venue</h2>
        <p className="text-gray-600">
          This agreement is governed by the laws of the State of Texas. All disputes must be resolved in Fort Bend County, Texas. If any provision is found unenforceable, the remainder will remain in full effect.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">7. Amendments</h2>
        <p className="text-gray-600">
          {webData?.companyName} reserves the right to update these terms at any time without notice. All changes will be effective upon posting on our website.
        </p>
      </section>
    </div>
  );
};

export default Terms;